import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true
}
